import React, { useState, useEffect  } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate ,useLocation} from "react-router-dom";
import { Formik, Field, Form, ErrorMessage, validateYupSchema } from "formik";
import * as Yup from "yup";
import CircularProgress from '@mui/material/CircularProgress';
import { Box, Button, TextField, Typography ,Stack,FormControlLabel,Checkbox } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { updateSignMessage,createSignMessage } from "../../slices/sign_message";
import Header from "../../components/global/Header";


import { login } from "../../slices/auth";
import { clearMessage, setMessage } from "../../slices/message";
import { CheckBox } from "@mui/icons-material";


const SignMessageEdit = (props) => {

  const isNonMobile = useMediaQuery("(min-width:600px)");

  const dispatch = useDispatch();

  const message = props.message;
  const closerFunc = props.closer;
  const senderFunc = props.sender;
  const signId = props.signId;
  
  let initialValues = {
    id:  0,
    name: "",
    message: "",
    sendMessage: true,
  };

  let createMode = false;

  if (message == undefined){
    createMode = true;
  }
  else{
    createMode = false;
    
    initialValues = {
      id: message.id,
      name: message.name,
      message: message.message,
      sendMessage: true,
    };
  }
  


  useEffect(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  

  const validationSchema = Yup.object().shape({

    name: Yup.string().required("This field is required!")
    .min(6, 'Must be a min of 6 chars'),
    message: Yup.string().required("This field is required!")
    .min(6, 'Must be a min of 6 chars'),
  });

  return (

    <Box m="20px">

      <Header title ={createMode ? "Create new Sign Message" : "Edit Message"}/>

      <Formik
         onSubmit={(values,actions) => {

          dispatch(clearMessage())

          if (createMode){

            const message = {
              signId: signId,
              name: values.name,
              message: values.message,
            }

            dispatch(createSignMessage({message}))
            .unwrap()
            .then(response => {

              if (values.sendMessage)
              {
                let messageId = response.data.id;

                senderFunc(signId,messageId)
              }
              closerFunc(true);
            })
            .catch(() => {
              actions.setSubmitting(false)
            });

          }else{

            const message = {
              signId: signId,
              id: values.id,
              name: values.name,
              message: values.message,
            }

            dispatch(updateSignMessage({message}))
            .unwrap()
            .then(response => {

              if (values.sendMessage)
              {
                let messageId = response.data.id;

                senderFunc(signId,messageId)
              }
              closerFunc(true);
            })
            .catch(() => {
              actions.setSubmitting(false)
            });

          }


          
  
      }}
          validationSchema={validationSchema}
          initialValues={initialValues}
          //enableReinitialize
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            handleReset,
            isSubmitting,
            isValid,
            dirty,
            
          }) => (
          <form onSubmit={handleSubmit}>

            

            <Box
            width="450px"
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(1, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 1" },
              }}
            >
              <TextField
                fullWidth
                variant="outlined"
                type="text"
                label="Message Name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={!!touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                sx={{ gridColumn: "span 1" }}
              />

              <TextField
                fullWidth
                variant="outlined"
                type="text"
                label="Message"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.message}
                name="message"
                error={!!touched.message && !!errors.message}
                helperText={touched.message && errors.message}
                sx={{ gridColumn: "span 1" }}
              />
              
              <FormControlLabel
                control={<Checkbox />}
                label="Send to sign on save?"
                onBlur={handleBlur}
                onChange={handleChange}
                checked={values.sendMessage}
                name="sendMessage"
                sx={{ gridColumn: "span 1" }}
                labelPlacement="end"
              />

              
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
            <Stack direction="row" spacing={2}>
                <Button type="button" color="error" variant="contained" onClick={closerFunc}>
                    Cancel
                </Button>

                <Button type="submit" color="secondary" variant="contained" 
                  disabled = {isSubmitting || !isValid || !dirty}
                >
                    Save
                </Button>
              </Stack>
            </Box>

            

          </form>
        )}
      </Formik>
    </Box>

  );

};

export default SignMessageEdit;